import { GameStatues, IGame } from "@grassrootly/api/entities";
import { provider } from "../../providers";

export interface SetGameStatusPayload {
  game: IGame;
  newStatus: GameStatues;
}

export const SetGameStatus = async (params: SetGameStatusPayload): Promise<IGame> => {
  // deep clone hack
  const game: IGame = JSON.parse(JSON.stringify(params.game));
  game.status = params.newStatus;
  return game; 
  // provider.Request("/games/status", params);
}
